import {
  Box,
  Button,
  Card,
  Grid,
  Group,
  Image,
  rem,
  Space,
  Stack,
  Text,
} from "@mantine/core";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import ApprovalInfoCard from "../../components/ApprovalInfoCard";
import { UseFormReturnType } from "@mantine/form";
import { IForm } from "../type";
import useSavingStore from "@/stores/SavingStore/savingStore";
import { toCurrency } from "@/utils/common";
import useAuth from "@/hooks/useAuth";
import IconCard from "@/assets/images/pngs/Icon_Card.png";
import { beText } from "@/utils/beText";

interface TermDepositStepTwoProps {
  form: UseFormReturnType<IForm>;
  onSubmit: () => void;
  onBackStepOne?: () => void;
  isLoading?: boolean;
}
const TermDepositStepTwo: React.FC<TermDepositStepTwoProps> = ({
  form,
  onSubmit,
  onBackStepOne,
  isLoading,
}) => {
  const { t } = useTranslation();
  const [storeSaving] = useSavingStore();
  const { user } = useAuth();

  console.log("user", user);

  const titleClassType = () => {
    switch (form.values.savingsClassType) {
      case "PAID_AT_BEGINNING":
        return t("START_OF_TERM");
      case "PAID_PERIODICALLY":
        return t("PERIODIC");
      case "PAID_AT_MATURITY":
        return t("END_OF_TERM");
      default:
        return "";
    }
  };

  const titleInterest = () => {
    switch (form.values.savingsClassType) {
      case "PAID_AT_BEGINNING":
        return t("EXPECTED_START_OF_TERM_INTEREST_LABEL");
      case "PAID_PERIODICALLY":
        return t("PERIODIC_INTEREST_PAYMENT");
      case "PAID_AT_MATURITY":
        return t("EXPECTED_END-OF-PERIOD_PROFIT");
      default:
        return "";
    }
  };
  console.log("form.values", form.values);
  return (
    <>
      <Grid>
        <Grid.Col span={12} md={8}>
          <Card padding="lg" radius="md">
            <Text fw={600} fz={20} c="#212936">
              {t("SOURCE_ACCOUNT")}
            </Text>
            <Space h={16} />
            <Group
              className="prt-formacc-group"
              bg="linear-gradient(279.48deg, #08AAF3 -9.02%, #2A81D0 10.15%, #10436E 99.12%)"
              style={{ padding: "16px", borderRadius: "8px" }}
            >
              <Box
                sx={{
                  background: "#FDFDFD",
                  padding: "4px",
                  borderRadius: "50%",
                }}
              >
                <Image src={IconCard} width={44} height={44} />
              </Box>
              <div style={{ flex: 1 }}>
                <Text
                  size="md"
                  weight={500}
                  className="prt-total-balanceAmount"
                  style={{ color: "#fff" }}
                >
                  {form.values.sourceAccount}
                </Text>
                <Text
                  size="sm"
                  weight={400}
                  c="dimmed"
                  style={{ color: "#fff" }}
                >
                  {t("TECHNOLOGY_JOINT_STOCK_COMPANY")} Proton
                </Text>
              </div>
              <Text size="md" weight={500} color="#FFFFFF">
                {toCurrency(Number(form.values.sourceAvailable))} VND
              </Text>
            </Group>
            <Space h={20} />
            <Stack spacing={24}>
              <Grid>
                {storeSaving.detailParams &&
                  storeSaving.detailParams.map((item) => {
                    const displayValue =
                      item.key === "Người tạo"
                        ? user?.fullName ?? ""
                        : item.value;
                    return (
                      <Fragment key={item.key}>
                        <Grid.Col span={3}>
                          <Text c="dimmed" fz={16}>
                            {beText(item.key)}
                          </Text>
                        </Grid.Col>
                        <Grid.Col span={9}>
                          <Text
                            fw={500}
                            c={
                              item.key === "Tổng tiền gửi"
                                ? "#0171BB"
                                : "#121826"
                            }
                            fz={16}
                          >
                            {beText(displayValue)}
                          </Text>
                        </Grid.Col>
                      </Fragment>
                    );
                  })}
                {form.values.method && (
                  <>
                    <Grid.Col span={12}>
                      <Text fw={600} fz={20}>
                        {t("RECURRING_DEPOSIT_INFORMATION")}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={3}>
                      <Text c="dimmed" fz={16}>
                        {t("DEPOSIT_METHOD")}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={9}>
                      <Text fw={500} fz={16}>
                        {form.values.method === "MANUAL"
                          ? t("MANUAL")
                          : t("AUTOMATIC")}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={3}>
                      <Text c="dimmed" fz={16}>
                        {t("DEPOSIT_CYCLE")}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={9}>
                      <Text fw={500} fz={16}>
                        {form.values.frequency === "MONTHLY"
                          ? t("MONTHLY")
                          : t("QUARTERLY")}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={3}>
                      <Text c="dimmed" fz={16}>
                        {t("RECURRING_DEPOSIT")}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={9}>
                      <Text fw={500} fz={16} c="#0171BB">
                        {form.values.amount}
                      </Text>
                    </Grid.Col>
                  </>
                )}
              </Grid>
            </Stack>
          </Card>
        </Grid.Col>
        <Grid.Col span={12} md={4}>
          <ApprovalInfoCard />
        </Grid.Col>
      </Grid>

      {/* Footer luôn ở cuối */}
      <Group position="center" mt={rem(20)}>
        <Box
          style={{
            position: "fixed",
            bottom: 0,
            right: 20,
            width: "calc(100% - var(--mantine-navbar-width, 0px) - 40px)",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "right",
            gap: "10px",
            boxShadow: "0px 5px 15px 0px #00000026",
            height: "76px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <Button
            onClick={onBackStepOne}
            sx={() => ({
              width: "160px",
              background: "#F4F4F6",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 600,
              color: "black",
              ":hover": {
                background: "#F4F4F6",
                color: "black",
              },
            })}
            mr="xs"
            type="reset"
          >
            {t("DISMISS")}
          </Button>
          <Button
            sx={() => ({
              width: "160px",
              color: "white",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 400,
              ":hover": {
                color: "white",
              },
              background: "#2A81D0",
            })}
            loading={isLoading}
            type="submit"
            onClick={onSubmit}
          >
            {t("CONFIRM")}
          </Button>
        </Box>
      </Group>
    </>
  );
};

export default TermDepositStepTwo;
